<template>
    <div>
        <reports-base
            reports-name="targetReport"
            reports-title="Raport/ Kreta w rytmie muzyki"
            component-name="Targetowka"
            :results-phrase="resultsPhrase"
            :contact-placeholder="showContactPlaceholder"
        >
            <div v-if="targetowkaReport">
                <h3 class="mt-5">Dane podstawowe</h3>
                <div
                    class="a-infoBar pl-3 mt-3 d-flex align-items-lg-center flex-lg-row flex-column text-dark"
                    style="gap: 0 1rem"
                >
                    <div style="flex: 2">
                        <p class="typo--lg mt-0 font-weight-normal mb-1">
                            Twoja grupa zakupowa: <br /><strong>{{
                                info['Twoja grupa zakupowa']
                            }}</strong>
                        </p>
                        <p class="typo--lg mt-0 font-weight-normal mb-1">
                            NIP: <br /><strong>{{
                                info['NIP']
                            }}</strong>
                        </p>
                        <p class="typo--lg mt-0 font-weight-normal mb-1">
                            SAP: <br /><strong>{{
                                info['SAP']
                            }}</strong>
                        </p>
                    </div>
                    <div style="flex: 4">
                        <p class="typo--lg mt-1 mb-0" style="flex: 1">
                            Adres: <br /><strong>{{ shopAddress }}</strong>
                        </p>
                        <p class="typo--lg mt-0 font-weight-normal mb-0">
                            Partner: <br /><strong>{{
                                info['Partner']
                            }}</strong>
                        </p>
                        <p class="typo--lg mt-2 mb-0 font-weight-normal">
                            Data aktualizacji: <br /><strong>{{
                                info['Data aktualizacji']
                            }}</strong>
                        </p>
                    </div>
                </div>

                <template v-if="targetowkaReport.info_2">
                    <h3 class="mt-5" v-text="'Informacja'" />

                    <ui-data-table :table-data="{
                        body: [
                            [
                                {
                                    text: targetowkaReport.info_2,
                                    customClass: 'font-weight-bold'
                                }
                            ]
                        ]
                    }"
                    />
                </template>

                <template v-if="pointsTable">
                    <h3 class="mt-5" v-text="'Wyniki akcji'" />
                    <ui-data-table :table-data="pointsTable" />
                </template>

                <!-- <h3 class="mt-5">Szczegóły realizacji</h3>
                <ui-data-table :table-data="resultsTable" /> -->

                <template v-if="filar1">
                    <h3 class="mt-5">Filar I - Total plan zakupowy</h3>
                    <ui-data-table :table-data="filar1" />
                </template>

                <template v-if="filar2">
                    <h3 class="mt-5">Filar II - Plany jednostkowe</h3>
                    <ui-data-table :table-data="filar2" />
                </template>

                <template v-if="filar3">
                    <h3 class="mt-5">Filar III - Zadania jakościowe</h3>
                    <ui-data-table :table-data="filar3" />
                </template>

                <template v-if="additional_points">
                    <h3 class="mt-5">Zbieraj dodatkowe punkty</h3>
                    <ui-data-table :table-data="additional_points" />
                </template>
            </div>
        </reports-base>
    </div>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    name: 'Targetowka',
    components: {
        ReportsBase
    },
    computed: {
        targetowkaReport() {
            return this.$store.getters.getTargetReportData
        },
        info() {
            return (this.targetowkaReport || {}).info
        },
        resultsPhrase() {
            if (!this.$store.getters.getTargetReportFilters.merchantId.value) {
                return 'Wybierz sklep w filtrze, aby wyświetlić raport'
            }

            return ''
        },
        showContactPlaceholder() {
            return !this.resultsPhrase && !this.$store.getters.getTargetReport
        },
        shopAddress() {
            const info = this.info
            return `${info.Ulica} ${info['Nr budynku']} ${
                info['Nr lokalu'] ? '/' + info['Nr lokalu'] : ''
            }, ${info['Kod pocztowy']} ${info['Miejscowość']}`
        },
        pointsTable() {
            const points = this.targetowkaReport.points || {}

            // reorder
            let sortedPoints = {}
            const hasOrderProperty = Object.values(points).some(function(item) {
                // eslint-disable-next-line no-prototype-builtins
                return item.hasOwnProperty('order')
            })
            if (hasOrderProperty) {
                sortedPoints = Object.entries(points)
                    .sort(([key1, value1], [key2, value2]) => {
                        const order1 = value1.order || Infinity
                        const order2 = value2.order || Infinity
                        return order1 - order2
                    })
                    .reduce((acc, [key, value]) => {
                        acc[key] = value
                        return acc
                    }, {})
                Object.values(sortedPoints).forEach(value => {
                    delete value.order
                })
            } else {
                const order = ['field_8', 'points_total', 'target_minimum']
                order.forEach(function(key) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (points.hasOwnProperty(key)) {
                        sortedPoints[key] = points[key]
                    }
                })
                Object.keys(points).forEach(function(key) {
                    if (!order.includes(key)) {
                        sortedPoints[key] = points[key]
                    }
                })
            }

            const body = []
            for (const [key, values] of Object.entries(sortedPoints)) {
                const row = Object.values(values).map((el, idx) => {
                    let text = el === '' ? '-' : el.toString()

                    if (key === 'target_minimum' || key === 'points_total' || key === 'field_8') {
                        text = `<span class="font-weight-bold">${text}</span>`
                    }

                    return { text }
                })
                body.push(row)
            }

            return { body }
        },
        filar1() {
            if (!this.targetowkaReport.filar_1) {
                return {}
            }

            const head = {}
            head.label = {
                text: '',
                thCustomClass: ''
            }
            head.target = {
                text: 'Target (zł)',
                thCustomClass: 'text-center col-min-width'
            }
            head.sales = {
                text: 'Obrót (zł)',
                thCustomClass: 'text-center col-min-width'
            }
            head.percentage = {
                text: 'Realizacja',
                thCustomClass: 'text-center col-min-width col-min-width--realization'
            }

            const { head: tableHead, body } = this.prepareTable({ head, data: this.targetowkaReport.filar_1.results })

            return { head: tableHead, body }
        },
        filar2() {
            if (!this.targetowkaReport.filar_2) {
                return {}
            }

            const head = {}
            head.label = {
                text: '',
                thCustomClass: ''
            }
            head.target = {
                text: 'Plan jednostkowy (zł)',
                thCustomClass: 'text-center col-min-width'
            }
            head.sales = {
                text: 'Obrót (zł)',
                thCustomClass: 'text-center col-min-width'
            }
            head.percentage = {
                text: 'Realizacja (%)',
                thCustomClass: 'text-center col-min-width col-min-width--realization'
            }

            const { head: tableHead, body } = this.prepareTable({ head, data: this.targetowkaReport.filar_2.results })

            return { head: tableHead, body }
        },
        filar3() {
            if (!this.targetowkaReport.filar_3) {
                return {}
            }

            const head = {}
            head.label = {
                text: '',
                thCustomClass: ''
            }
            head.value = {
                text: 'Realizacja',
                thCustomClass: 'text-center col-min-width col-min-width--realization'
            }

            const { head: tableHead, body } = this.prepareTable({ head, data: this.targetowkaReport.filar_3.results })

            return { head: tableHead, body }
        },
        additional_points() {
            if (!this.targetowkaReport.additional_points) {
                return {}
            }

            const head = {}
            head.label = {
                text: '',
                thCustomClass: ''
            }
            head.value = {
                text: 'Realizacja',
                thCustomClass: 'text-center col-min-width col-min-width--realization'
            }

            // Convert object this.targetowkaReport.additional_points to array
            const data = Object.values(this.targetowkaReport.additional_points)

            const { head: tableHead, body } = this.prepareTable({ head, data })

            return { head: tableHead, body }
        },
        resultsTable() {
            const [head, ...results] = this.targetowkaReport.filar_1.results

            head.toDo = {
                text: 'Do realizacji (zł)',
                thCustomClass: 'text-center'
            }
            head.sales = {
                text: `${head.sales} (zł)`,
                thCustomClass: 'text-center'
            }
            head.target = {
                text: `${head.target} (zł)`,
                thCustomClass: 'text-center'
            }
            head.group = {
                text: head.group,
                thCustomClass: 'text-center'
            }

            const body = results.map(result => {
                const row = []
                for (let [rKey, rVal] of Object.entries(result)) {
                    if (!head[rKey]) {
                        continue
                    }

                    if (!rVal) {
                        rVal = '-'
                    }

                    if (
                        (rKey === 'target' || rKey === 'sales') &&
                        rVal !== '-'
                    ) {
                        rVal = this.$options.filters.number((+rVal).toFixed(2))
                    }

                    let cellClass = 'justify-content-between'
                    if (rKey !== 'manufacturer') {
                        cellClass = 'justify-content-center'
                    }

                    rVal = `<div class="d-flex gap-1 ${cellClass}"><span class="d-md-none">${
                        typeof head[rKey] === 'string'
                            ? head[rKey]
                            : head[rKey].text
                    }</span> <span class="text-right text-md-left">${rVal}</span></div>`
                    row.push({ text: rVal })
                }

                let toDo = +result.target - +result.sales
                if (toDo <= 0) {
                    toDo =
                        '<span class="font-weight-bold text-success">ZREALIZOWANO</span>'
                }
                row.push({
                    text: `<div class="d-flex gap-1 justify-content-center"><span class="d-md-none">${
                        head.toDo.text
                    }</span> <span class="text-right text-md-left">${
                        typeof toDo === 'number'
                            ? this.$options.filters.number(toDo.toFixed(2))
                            : toDo
                    }</span></div>`
                })
                return row
            })

            return { body, head, tableClass: '--rwd-bold-values' }
        }
    },
    methods: {
        prepareTable({ head, data }) {
            const body = data.map(result => {
                const row = []

                for (let [rKey, rVal] of Object.entries(result)) {
                    if (!head[rKey]) {
                        continue
                    }

                    if (!rVal) {
                        rVal = '-'
                    }

                    if (rKey === 'target' || rKey === 'sales') {
                        if (typeof rVal === 'string' && rVal.includes(',')) {
                            rVal = rVal.replace(',', '.')
                        }

                        rVal = this.$options.filters.currency(
                            (+rVal)
                        )
                    }

                    let cellClass = 'justify-content-center justify-content-md-start'
                    if (rKey !== 'label') {
                        cellClass = 'justify-content-center'
                    }

                    if (rKey === 'value') {
                        rVal = `
                            <div class="d-flex gap-1 justify-content-center">
                                <span class="d-md-none font-weight-bold text-center">${head.value.text}</span>
                                <span class="text-center text-md-left ${rVal.toLowerCase() === 'tak' && 'text-success font-weight-bold'}">
                                    ${rVal.toLowerCase() === 'tak' ? 'TAK' : 'NIE'}
                                </span>
                            </div>
                        `
                    } else if (rKey === 'percentage') {
                        let isDone = false
                        let txt = '-'
                        if (typeof rVal === 'number') {
                            isDone = rVal >= 100
                            txt = isDone ? 'TAK' : rVal + ' %'
                        }

                        rVal = `<div class="d-flex gap-1 justify-content-center">
                            <span class="d-md-none font-weight-bold text-center">${head.percentage.text}</span>
                            <span class="text-center text-md-left ${isDone && 'text-success font-weight-bold'}">${txt}</span>
                        </div>`
                    } else {
                        rVal = `<div class="d-flex gap-1 ${cellClass}"><span class="d-md-none font-weight-bold text-center">${
                            typeof head[rKey] === 'string'
                                ? head[rKey]
                                : head[rKey].text
                        }</span> <span class="text-center text-md-left">${rVal}</span></div>`
                    }

                    // if (rKey !== 'percentage') {
                    //     row.push({ text: rVal })
                    // }
                    row.push({ text: rVal })
                }

                if (!result.target || !result.sales) {
                    return row
                }

                // // Calculate percentage
                // const percentage = ((result.sales / result.target) * 100).toFixed(2)
                // const isDone = percentage >= 100

                // row.push({
                //     text: `
                //         <div class="d-flex gap-1 justify-content-center">
                //             <span class="d-md-none">${head.percentage.text}</span>
                //             <span class="text-right text-md-left ${isDone && 'text-success font-weight-bold'}">
                //                 ${isDone ? 'TAK' : percentage.replace('.', ',') + ' %'}
                //             </span>
                //         </div>
                //     `
                // })

                return row
            })

            return { head, body }
        }
    },
    created() {
        if (!this.$store.getters.getTargetReportLocationsByAvailableNetworks.length) {
            this.$router.push({ name: 'permission-denied' })
        }
        this.$store.dispatch('extendedDataFetch', {
            includes: 'companies'
        })
        // this.$store.dispatch('setTargetReportDefaultMerchant')
    }
}
</script>

<style lang="scss">
.col-min-width {
    width: 140px;

    &--realization {
        width: 120px;
    }
}
</style>